import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { BarLoader } from "react-spinners";

export default function() {
  const { children, close, loader } = this.props;
  return (
    <div className="dialog">
      {loader ? (
        <BarLoader width={200} color={"var(--primary-color)"} />
      ) : (
        <div>
          <div className="dialog-close" onClick={close}>
            <FontAwesomeIcon icon={faTimesCircle} size="2x" />
          </div>
          <div className="dialog-body">{children}</div>
        </div>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/dialog/view.js